import lms from '@/http/lms'

export default {
  namespaced: true,
  state: {
    quiz: {},
    quizFollow: []
  },
  getters: {
    getQuiz: (state) => (quizID) => state.quiz[quizID],
    getQuizFollow: (state) => state.quizFollow
  },
  mutations: {
    setQuizFollow(state, quizFollow) {
      state.quizFollow = quizFollow
    },
    setQuiz(state, quiz) {
      state.quiz[quiz.quizID] = quiz
    },
    setQuestionAnswer(state, { quizID, questionID, answer }) {
      // const questionIndex = state.quiz[quizID].quizQuestions.findIndex((question) => question.questionID === questionID)

      // state.quiz[quizID].quizQuestions[questionIndex]._$.answerSelected = answer
      // state.quiz[quizID].quizQuestions[questionIndex].alreadyAnswered = true
    }
  },
  actions: {
    async getUserQuizFollow({ commit }) {
      const response = await lms.get('/quiz-follow')

      const quizFollows = response.data.data

      commit('setQuizFollow', quizFollows)

      quizFollows.forEach((follow) => {
        commit('setQuestionAnswer', { quizID: follow.quizID, questionID: follow.questionID, answer: follow.questionAnswer })
      })
    },
    async getQuiz({ commit }, quizID) {
      const response = await lms.get(`/quizzes/${quizID}`)

      const quizQuestionsFormatted = response.data.data.quizQuestions.map((question, questionIndex) => ({
        ...question,
        _$: { questionIndex, answerSelected: null }
      }))

      commit('setQuiz', { ...response.data.data, quizQuestions: quizQuestionsFormatted })

      return response
    },
    async createQuizFollow({ commit }, quizFollow) {
      commit('setQuestionAnswer', {
        quizID: quizFollow.quizID,
        questionID: quizFollow.questionID,
        answer: quizFollow.questionAnswer,
        courseID: quizFollow.courseID
      })

      const response = await lms.post('/quiz-follow', { ...quizFollow })
    }
  }
}
